module.exports = __webpack_public_path__ + "img/finishing.25bc43fa.svg";